<template>
    <v-row>
        <v-col cols="4">
            <v-card>
                <v-card-title>Last-minute Discount </v-card-title>
                <!-- <v-row no-gutters>
                    <v-col cols="12" class="px-5"><p>(Not yet in use in price calculation)</p></v-col>
                </v-row> -->
                <v-row no-gutters>
                    <v-col cols="12" class="px-5">
                        <v-select v-model="lmdc_nr" :items="huisDiscounts.lm_choices" item-text="choice_oms" item-value="nr">
                            <template v-slot:selection="{ item }">
                                <span><span><v-avatar size="22" class="white--text font-weight-bold" color="blue">{{ item.nr }}</v-avatar></span> {{ item.choice_oms }}</span>
                            </template>

                            <template v-slot:item="{ item }">
                                <span><span><v-avatar size="22" class="white--text font-weight-bold" color="blue">{{ item.nr }}</v-avatar></span> {{ item.choice_oms }}</span>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="px-1">
                        <v-card-text>
                        <b v-if="lmdc_nr > 0"><span class="pt-4">Current last-minute discount:</span> <v-avatar size="22" class="white--text font-weight-bold" color="blue">{{ lmdc_nr }}</v-avatar><br></b>
                            <span v-if="lmdc_nr == 0">No last-minute discount</span>
                            <span v-for="(lm_line, lml) in huisDiscounts.lm_choices.find(({ nr }) => nr === lmdc_nr).lines.slice().reverse()" :key="lml">
                            <b>{{ lm_line.days_from }} - {{ lm_line.days_to }}</b> days before arrival <b>{{ lm_line.perc }}%</b> <br>
                        </span>
                    </v-card-text>
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="primary mx-2" small @click="saveHuisLmdc">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        <v-col cols="8">
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>Current & Future Other Discounts<v-spacer></v-spacer>
                            <v-btn class="primary ma-2" x-small v-if="huisDiscounts.hsabCurrentBasic.length > 0 || lmdc_nr > 0" @click="copyHsab(huisDiscounts.hsabCurrentBasic,huisDiscounts.lm_choices,lmdc_nr)"><v-icon small>mdi-content-copy</v-icon> Copy Discount(s)</v-btn>
                            <v-btn class="primary ma-2" x-small @click="addHsab2(huisDiscounts.huis_encrid)">Add Discount</v-btn>
                            <btn_audit table="hsab" :encrid="this.huis_encrid" :size=30 tooltip="audit of accommodation - Discounts" />
                        </v-card-title>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                    <td>Stay within</td>
                                    <td>Booking within</td>
                                    <td>% Guest</td>
                                    <td>% Host</td>
                                    <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(hsabRecord, i) in huisDiscounts.hsabCurrentBasic" :key="i">
                                    <td>{{ hsabRecord.hsab_verb }}</td>
                                    <td>{{ hsabRecord.hsab_boek }}</td>
                                    <td>{{ hsabRecord.hsab_kort_perc_verkoop }}%</td>
                                    <td>{{ hsabRecord.hsab_kort_perc_inkoop }}%</td>
                                    <td> <v-btn text icon @click="rmHsab2(hsabRecord.hsab_encrid)"><v-icon
                                            small>mdi-trash-can-outline</v-icon></v-btn></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <!-- <addHsab2 ref="addHsab2" @updateData="updateData"></addHsab2>
                        <rmHsab2 ref="rmHsab2" @updateData="updateData"></rmHsab2>
                        <copyHsab ref="copyHsab" @updateData="updateData"></copyHsab> -->
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>Expired Basic Discounts <span v-if="huisDiscounts.hsabExpired.length > 0" class=ml-2> ({{
                        huisDiscounts.hsabExpired.length }})</span><v-spacer></v-spacer>
                        <btn_audit table="hsab" :encrid="huisDiscounts.huis_encrid" :size=30
                          tooltip="audit of accommodation - Discounts" />
                        </v-card-title>
                        <v-simple-table dense fixed-header
                            :height="huisDiscounts.hsabExpired.length > 5 ? '216px' : `${40 + (huisDiscounts.hsabExpired.length * 40)}px`" class="pa-2">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Stay within</th>
                                        <th>Booking within</th>
                                        <th>% Guest</th>
                                        <th>% Host</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(hsabRecord, i) in huisDiscounts.hsabExpired" :key="i">
                                        <td>{{ hsabRecord.hsab_verb }}</td>
                                        <td>{{ hsabRecord.hsab_boek }}</td>
                                        <td>{{ hsabRecord.hsab_kort_perc_verkoop }}%</td>
                                        <td>{{ hsabRecord.hsab_kort_perc_inkoop }}%</td>
                                        <td> <v-btn text
                                        icon @click="rmHsab2(hsabRecord.hsab_encrid)"><v-icon
                                            small>mdi-trash-can-outline</v-icon></v-btn></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <!-- <addHsab2 ref="addHsab2" @updateData="updateData"></addHsab2>
                        <rmHsab2 ref="rmHsab2" @updateData="updateData"></rmHsab2> -->
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
        <addHsab2 ref="addHsab2" @updateData="updateData"></addHsab2>
        <rmHsab2 ref="rmHsab2" @updateData="updateData"></rmHsab2>
        <copyHsab ref="copyHsab" @updateData="updateData"></copyHsab>
    </v-row>
</template>

<script>
import btn_audit from "@/components/ui/buttons/btn_audit.vue";
import rmHsab2 from "@/views/huis/hsab/rmHsab2.vue";
import addHsab2 from "@/views/huis/hsab/addHsab2.vue";
import copyHsab from "@/views/huis/hsab/copyHsab.vue";
// import { bus } from "../../../main";

export default {
    components:{
        btn_audit,
        rmHsab2,
        addHsab2,
        copyHsab,
    },
    props: {
        huis_encrid: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            loading: true,
            loader: null,
            huisDiscounts: {hsabCurrentBasic:[],hsabExpired:[],lm_choices:[{nr:0,choice_oms:'',lines:[]}],huis_encrid:''},
            lmdc_nr: 0,
        }
    },
    mounted() {
        this.getHuisDiscounts();
    },
    created() {
    //   bus.$on("closeDialog", (data) => {
    //     console.log(data);
    //     if (data === 'reload' || data === 'attm_m_attm') {
    //         this.getHuisDiscounts();
    //     }
    //   });
    //   this.getHuisDiscounts();
    },
    watch: {
        loader () {
            const l = this.loader
            this[l] = !this[l]
        },
    },
    methods: {
        updateData(){
            this.getHuisDiscounts();
        },
        getHuisDiscounts() {
                this.$axios.post("ares/json/ares/huis/getHuisDiscounts.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisDiscounts"
                    },
                    getHuisDiscounts: {
                        huis_encrid: this.huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.huisDiscounts = res.data.getHuisDiscounts;
                        this.lmdc_nr = res.data.getHuisDiscounts.lmdc_nr;
                        this.loading = false;
                    }
                });
        },
        saveHuisLmdc(){
            this.$axios.post("ares/json/ares/huis/saveHuisLmdc.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveHuisLmdc"
                    },
                    saveHuisLmdc: {
                        huis_encrid: this.huis_encrid,
                        lmdc_nr: this.lmdc_nr
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.saveHuisLmdc.text,
                            color: res.data.saveHuisLmdc.color
                        });
                        this.loading = false;
                    }
                });

        },
        addHsab2(huis_encrid) {
            this.$refs.addHsab2.open(huis_encrid);
        },
        copyHsab(hsabRecords,lm_choices,lmdc_nr) {
            this.$refs.copyHsab.open(hsabRecords,lm_choices,lmdc_nr);
        },
        rmHsab2(hsab_encrid) {
            this.$refs.rmHsab2.open(hsab_encrid);
        },
    },
}
</script>